import styles from '../styles/Header.module.css'
import Button from '../components/playbook/Button'
import Flex from '../components/playbook/Flex'

type HeaderProps = {
  domain: string
}

const Header = (props: HeaderProps) => (
  <header>
    <Flex
      align="center"
      justify="between"
      marginBottom="xl"
      paddingBottom="xl"
    >
      <img
        alt={props.domain === "streaminnovations" ? "Stream Innovations Logo" : "Stream Financial Logo"}  
        src={props.domain == "streaminnovations" ? "/images/stream-innovations-logo-dark-bg.png" : "/images/stream-financial-logo.png"}
        width="120"
      />
      <Button
          className={styles.headerButton}
          link={"https://customer.streaminnovations.com"}
          newWindow
          text={"Sign In"}
          variant={"primary"}
      />
    </Flex>
  </header>
);

export default Header;
